module.exports = __webpack_public_path__ + "img/5.6fb84cf7.png";